import { ProductCategory, RidangoReduxAction } from '@ridango/core';
import { tassign } from 'tassign';
import { ProductCategoriesActions } from './product-categories.actions';

export interface ProductCategoriesState {
    allCategories: ProductCategory[];
    filteredTravellerCategories: ProductCategory[];
    selectedTravellerCategory: ProductCategory;
    filteredProductCategories: ProductCategory[];
    selectedProductCategory: ProductCategory;
    byId: { [id: string]: ProductCategory };
    allIds: any[];
    types: string[];
    categoryIdsByType: any;
    selectedCategoryIdByType: any;
    // areaCategoryIds: any[];
    // travellerCategoryIds: any[];
    // productCategoryIds: any[];
    loaded: boolean;
    error: any;
}
export const PRODUCT_CATEGORIES_INITIAL_STATE: ProductCategoriesState = {
    allCategories: [],
    filteredTravellerCategories: [],
    selectedTravellerCategory: null,
    filteredProductCategories: [],
    selectedProductCategory: null,
    byId: null,
    allIds: [],
    types: [],
    categoryIdsByType: null,
    selectedCategoryIdByType: null,
    // areaCategoryIds: [],
    // travellerCategoryIds: [],
    // productCategoryIds: [],
    loaded: false,
    error: null
};

export const PRODUCT_CATEGORIES_STATE_KEY = 'productCategories';

export function productCategoriesReducer(
    lastState: ProductCategoriesState = PRODUCT_CATEGORIES_INITIAL_STATE,
    action: RidangoReduxAction
): ProductCategoriesState {
    switch (action.type) {
        case ProductCategoriesActions.SET_ALL_CATEGORIES:
            return tassign(lastState, { allCategories: action.payload });
        case ProductCategoriesActions.SET_FILTERED_TRAVELLER_CATEGORIES:
            return tassign(lastState, { filteredTravellerCategories: action.payload });
        case ProductCategoriesActions.SET_SELECTED_TRAVELLER_CATEGORY:
            return tassign(lastState, { selectedTravellerCategory: action.payload });
        case ProductCategoriesActions.SET_FILTERED_PRODUCT_CATEGORIES:
            return tassign(lastState, { filteredProductCategories: action.payload });
        case ProductCategoriesActions.SET_SELECTED_PRODUCT_CATEGORY:
            return tassign(lastState, { selectedProductCategory: action.payload });
        case ProductCategoriesActions.CLEAR_PRODUCT_CATEGORIES:
            return tassign(lastState, PRODUCT_CATEGORIES_INITIAL_STATE);
        case ProductCategoriesActions.FETCH_PRODUCT_CATEGORIES:
            return tassign(lastState, {
                loaded: false,
                error: null
            });
        case ProductCategoriesActions.FETCH_PRODUCT_CATEGORIES_SUCCESS:
            return tassign(lastState, {
                ...action.payload,
                loaded: true,
                error: null
            });
        case ProductCategoriesActions.FETCH_PRODUCT_CATEGORIES_FAILED:
            return tassign(lastState, {
                loaded: true,
                error: action.payload
            });
        case ProductCategoriesActions.SET_SELECTED_CATEGORY_BY_TYPE:
            return tassign(lastState, {
                selectedCategoryIdByType: {
                    ...lastState.selectedCategoryIdByType,
                    [action.payload.type]: action.payload.id
                }
            });
        case ProductCategoriesActions.SET_PRODUCT_CATEGORIES:
            return {
                ...lastState,
                categoryIdsByType: {
                    ...lastState.categoryIdsByType,
                    product: action.payload
                }
            };
        case ProductCategoriesActions.RESET_CATEGORY_SELECTIONS:
            return tassign(lastState, {
                selectedCategoryIdByType: null
            });
    }
    // We don't care about any other actions right now.
    return lastState;
}

export interface ProductCategoriesPartialStoreState {
    [PRODUCT_CATEGORIES_STATE_KEY]: ProductCategoriesState;
}
